export default __webpack_public_path__ + "static/media/LandRoverFavicon.2588446e.svg";